/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { ApolloError } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import ErrorPage from './error-page';

/**
 * TODO: will not report to sentry yet
 */
export function ApolloErrorPage({ error }: { error: ApolloError }) {
  const { t } = useTranslation();

  return (
    <ErrorPage
      message={t('error.we_track_these_error')}
      title={t('error.looks_like_something_wrong')}
    />
  );
}
